import { Table } from '@material-ui/core'
import { DadosConstrucao } from 'models/Viabilidade/Construcao'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableCellLabel, TableRowCinza, TableCellValor, TableRowBranca } from '../index.style'

const CartaoConstrucao: React.FC<{ dados: DadosConstrucao }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableConstrucao">
        <TableRowCinza>
          <TableCellLabel>Duração de Obra (meses)</TableCellLabel>
          <TableCellValor data-cy="campoDuracaoObra">
            <NumberFormat
              value={dados?.duracaoObra}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowBranca>
          <TableCellLabel>Colchão Lançamento - Obra (meses)</TableCellLabel>
          <TableCellValor data-cy="campoColchaoLancamento">
            <NumberFormat
              value={dados?.colchaoLancamento}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowCinza>
          <TableCellLabel>Prazo Total de Vendas (meses)</TableCellLabel>
          <TableCellValor data-cy="campoPrazoTotalVendas">
            <NumberFormat
              value={dados?.prazoTotalVendas}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoConstrucao
